import { ManageCertificationsTableData } from './ManageCertificationsTable/ManageCertificationsTable';
import { isNil } from 'lodash';
import {
  DocumentationRequiredPickerKey,
  RenewalRequiredPickerKey,
  EmployeeCanManagePickerKey,
  Certification,
} from './types';
import { ICertificationFormData } from './CertificationForm/CertificationForm';

export function getTrueFalseValueFromString(s: string | null): boolean | null {
  return s === 'true' ? true : s === 'false' ? false : null;
}

export function getDocumentationRequiredPickerKey(v: boolean | null): DocumentationRequiredPickerKey | null {
  return v === true ? 'documentationRequired' : v === false ? 'documentationNotRequired' : null;
}

export function getRenewalRequiredPickerKey(v: boolean | null): RenewalRequiredPickerKey | null {
  return v === true ? 'renewalRequired' : v === false ? 'renewalNotRequired' : null;
}

export function getEmployeeCanManagePickerKey(v: boolean | null): EmployeeCanManagePickerKey | null {
  return v === true ? 'employeeCanManage' : v === false ? 'employeeCantManage' : null;
}

export function getDocumentationRequiredFilterValue(key: DocumentationRequiredPickerKey | null): boolean | null {
  return key === 'documentationRequired' ? true : key === 'documentationNotRequired' ? false : null;
}

export function getRenewalRequiredFilterValue(key: RenewalRequiredPickerKey | null): boolean | null {
  return key === 'renewalRequired' ? true : key === 'renewalNotRequired' ? false : null;
}

export function getEmployeeCanManageFilterValue(key: EmployeeCanManagePickerKey | null): boolean | null {
  return key === 'employeeCanManage' ? true : key === 'employeeCantManage' ? false : null;
}

export function mapCertificationsToTableData(certifications: Certification[]): ManageCertificationsTableData[] {
  return certifications.map((item) => ({
    id: item.id,
    name: item.name,
    documentationRequired: item.documentationRequired,
    renewalRequired: !isNil(item.renewalPeriodMonths),
    employeeCanManage: item.employeeManaged,
    description: item.description,
    renewalPeriod: item.renewalPeriodMonths ?? undefined,
  }));
}

export function getMonthsYearsFromRenewalPeriod(certification: ManageCertificationsTableData): {
  months: string;
  years: string;
} {
  if (certification.renewalPeriod) {
    const years = Math.floor(certification.renewalPeriod / 12);
    const months = certification.renewalPeriod % 12;
    return { months: `${months}`, years: `${years}` };
  } else {
    return { months: '0', years: '0' };
  }
}

export function getRenewalPeriodMonths(formData: ICertificationFormData): number {
  const months = formData.expiredAfterMonths ? Math.floor(Number(formData.expiredAfterMonths)) : 0;
  const years = formData.expiredAfterYears ? Math.floor(Number(formData.expiredAfterYears)) : 0;

  return years * 12 + months;
}
